module.exports = __webpack_public_path__ + "static/media/29ADMSPC24.d2bf8d42.jpg";